/**
 * Register the console's service worker (PRD, briefing inputs: the PWA), in
 * production only and only where the browser has one; development and the
 * tests keep the plain page. Registration never blocks render, and a failure
 * leaves the console exactly as it was.
 */
export function registerServiceWorker(scope: { production: boolean; nav: Navigator; win: Window } = { production: import.meta.env.PROD, nav: navigator, win: window }): boolean {
  if (!scope.production || !('serviceWorker' in scope.nav)) return false;
  scope.win.addEventListener('load', () => {
    scope.nav.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).catch(() => undefined);
  });
  return true;
}
